'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _dec, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _statistics = require('redux/modules/statistics');

var statisticsActions = _interopRequireWildcard(_statistics);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _List = require('components/List/List');

var _List2 = _interopRequireDefault(_List);

var _ListItem = require('components/ListItem/ListItem');

var _ListItem2 = _interopRequireDefault(_ListItem);

var _ProjectStatsViewerRow = require('containers/Project/ProjectStatsViewerRow/ProjectStatsViewerRow');

var _ProjectStatsViewerRow2 = _interopRequireDefault(_ProjectStatsViewerRow);

var _Loader = require('components/Loader/Loader');

var _Loader2 = _interopRequireDefault(_Loader);

var _statistics2 = require('selectors/statistics');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var ProjectStatsViewersList = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    deleteLoaders: state.statistics.deleteStatsViewerLoaders,
    statsViewers: (0, _statistics2.getStatsViewers)(state),
    statsViewersLoading: state.statistics.statsViewersLoading
  };
}, (0, _extends3.default)({}, statisticsActions)), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(ProjectStatsViewersList, _Component);

  function ProjectStatsViewersList() {
    (0, _classCallCheck3.default)(this, ProjectStatsViewersList);
    return (0, _possibleConstructorReturn3.default)(this, (ProjectStatsViewersList.__proto__ || (0, _getPrototypeOf2.default)(ProjectStatsViewersList)).apply(this, arguments));
  }

  (0, _createClass3.default)(ProjectStatsViewersList, [{
    key: 'deleteViewer',
    value: function deleteViewer(_ref) {
      var viewer = _ref.viewer;
      var _props = this.props,
          projectId = _props.projectId,
          deleteStatsViewer = _props.deleteStatsViewer;

      return deleteStatsViewer({ projectId: projectId, email: viewer.userEmail });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          className = _props2.className,
          projectId = _props2.projectId,
          statsViewers = _props2.statsViewers,
          statsViewersLoading = _props2.statsViewersLoading,
          deleteLoaders = _props2.deleteLoaders;
      var t = this.context.t;


      return _react2.default.createElement(
        'div',
        { className: (0, _bind2.default)(className) },
        _react2.default.createElement(
          _List2.default,
          null,
          _react2.default.createElement(
            _ListItem2.default,
            { fullWidth: true, isTitle: true },
            _react2.default.createElement(
              'div',
              null,
              t('Name')
            ),
            _react2.default.createElement(
              'div',
              null,
              t('Email')
            ),
            _react2.default.createElement('div', null)
          ),
          statsViewers.map(function (viewer) {
            return _react2.default.createElement(_ProjectStatsViewerRow2.default, {
              key: viewer.userId,
              viewer: viewer,
              onDelete: _this2.deleteViewer,
              deleteLoaders: deleteLoaders,
              projectId: projectId
            });
          })
        ),
        _react2.default.createElement(_Loader2.default, { show: statsViewersLoading, small: true, alignCenter: true })
      );
    }
  }]);
  return ProjectStatsViewersList;
}(_react.Component), _class3.propTypes = {
  className: _propTypes2.default.string,
  deleteLoaders: _propTypes2.default.object,
  deleteStatsViewer: _propTypes2.default.func,
  projectId: _propTypes2.default.number,
  statsViewers: _propTypes2.default.array,
  statsViewersLoading: _propTypes2.default.bool
}, _class3.contextTypes = {
  t: _propTypes2.default.func
}, _class3.defaultProps = {
  onClick: _noop3.default,
  statsViewers: []
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'deleteViewer', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'deleteViewer'), _class2.prototype)), _class2)) || _class);
exports.default = ProjectStatsViewersList;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Project/ProjectStatsViewersList/ProjectStatsViewersList.js
// module id = 2200
// module chunks = 1